<template>
  <main class="grow">
    <Hero />
    <Story />
    <LazyVisibleSignalMoment :hydrate-on-visible="{ rootMargin: '200px' }" :moment="0" />
    <LazyVisibleFeatures2 class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleDetails :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleSignalMoment :hydrate-on-visible="{ rootMargin: '200px' }" :moment="1" reverse />
    <LazyVisibleThreeSixNine class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleProductMotion class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleSignalMoment :hydrate-on-visible="{ rootMargin: '200px' }" :moment="2" />
    <!-- Proof before price; the technical MCP/API sections follow pricing. -->
    <LazyVisibleHomeReviews class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }"
      :eyebrow="homeCopy.reviews.eyebrow"
      :title="homeCopy.reviews.title"
      :cta-label="homeCopy.reviews.cta"
    />
    <LazyVisibleHomePricingSection class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleCompetitorSwitchBand class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" location="home" />
    <LazyVisibleAiConnections class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleDeveloperApi class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <LazyVisibleBuildCrmBand class="home-render-later" :hydrate-on-visible="{ rootMargin: '200px' }" />
    <Cta03 />
    <HomeStickyCta />
  </main>
</template>

<script setup lang="ts">
const { seoCopy } = useWorkspaceLocale();
const homeCopy = useHomeCopy();

useHead(() => ({
  title: seoCopy.value.title,
  meta: [
    {
      key: "description",
      name: "description",
      content: seoCopy.value.description,
    },
    { key: "twitter-title", name: "twitter:title", content: seoCopy.value.title },
    {
      key: "twitter-description",
      name: "twitter:description",
      content: seoCopy.value.description,
    },
    {
      key: "twitter-card",
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      key: "og-title",
      property: "og:title",
      content: seoCopy.value.title,
    },
    {
      key: "og-description",
      property: "og:description",
      content: seoCopy.value.description,
    },
  ],
}));
</script>

<style scoped>
/* Keep offscreen sections searchable and accessible while the browser skips
   their layout/paint. Remember actual height once rendered. The scroll-driven
   Details section is deliberately excluded so its sticky geometry stays exact. */
.home-render-later {
  content-visibility: auto;
  contain-intrinsic-size: auto 900px;
}
</style>
